/**
 * A boolean remembered in localStorage, as '1' / '0'. Storage can be
 * unavailable (private window, blocked site data): a read then answers the
 * fallback and a write is dropped, so callers must render correctly without it.
 */

export function readFlag(key, fallback) {
  try {
    const value = window.localStorage.getItem(key);
    return value === null ? fallback : value === '1';
  } catch {
    return fallback;
  }
}

export function writeFlag(key, on) {
  try {
    window.localStorage.setItem(key, on ? '1' : '0');
  } catch {
    // ignore
  }
}
